import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PARK_DOCUMENT } from "./apiRoutes";

interface UseGetParkDocListProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getParkDocumentList = async (data: any) =>
  await axiosAuth.post(`${PARK_DOCUMENT}/grid`, data);

const useGetParkDocumentList = ({
  data,
  queryParams,
}: UseGetParkDocListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["park-documents"],
    queryFn: () => getParkDocumentList(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetParkDocumentList;
